<template>
  <div id="message">
    <form action class="_form" @submit.prevent="submit">
      <div class="mage-board">
        <div class="top">
          <span>留言</span>
          <i class="iconfont iconquxiao1" @click="showDialog()"></i>
        </div>

        <div class="wx_user">
          <img :src="headimgurl" class="wx_user_image" alt />
          <span class="wx_user_name">{{nickname}}</span>
        </div>

        <textarea class="mage-cont" v-model="iputContent" placeholder="请写下您的留言（最多可输入100字）"></textarea>
        <!-- <span class="submBtn" @click="getSub()">提交</span> -->
        <button class="submBtn">提交</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { putMsg } from "../api/new_msg";
export default {
  props: {
    dialog_visible: Boolean
  },
  data() {
    return {
      visible: this.dialog_visible,
      nickname: "",
      headimgurl: "",
      iputContent: ""
    };
  },
  watch: {
    visible(val) {
      this.dialog_visible = val;
    }
  },
  created() {
    this.nickname = this.userInfo.nickname;
    this.headimgurl = this.userInfo.headimgurl;
  },
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  methods: {
    showDialog(visible) {
      this.$emit("dialogVisibleEvent", false);
    },
    submit() {
      if (this.iputContent == "") {
        alert("内容不能为空");
      } else {
        const data = new FormData();
        var uuid = this.$route.query.id
        var cont = this.iputContent
        data.append("mt_uuid", uuid)
        data.append("content", cont)
        putMsg(data).then(res =>{
          this.$emit("dialogVisibleEvent", false);
        })
       
      }
    }
  }
};
</script>

<style scoped>
#message {
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
._form {
  width: 100%;
  display: flex;
  justify-content: center;
}
.mage-board {
  width: 75%;
  height: 385px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(15, 15, 15, 0.19);
  border-radius: 6px;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.top {
  width: 100%;
  height: 33px;
  background-color: #bbd4fc;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top > span {
  font-size: 1rem;
  color: #333333;
  padding-left: 15px;
}
.iconquxiao1 {
  font-size: 0.8rem;
  color: #fff;
  padding-right: 15px;
}
.wx_user {
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.wx_user_image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.wx_user_name {
  font-size: 15px;
  color: #333333;
  margin-left: 20px;
}
.code_txt {
  font-size: 15px;
  color: #333333;
  padding-left: 10px;
}
.inptCode {
  border: none;
  width: 35%;
  padding-left: 35px;
  outline: none;
}
.getCode {
  font-size: 15px;
  color: #2a5daf;
  background: #fff;
  text-align: center;
  border: 0;
  margin-left: 28px;
  outline: none;
}
.no_code {
  font-size: 11px;
  color: #999999;
  padding-top: 10px;
  padding-left: 62%;
}
.mage-cont {
  /* margin-left: 10px;
        margin-right: 10px; */
  width: 90% !important;
  height: 140px !important;
  margin-top: 7px;
  padding-top: 12px;
  padding-left: 12px;
  resize: none;
}
.submBtn {
  width: 100px;
  height: 30px;
  background: #f4b79d;
  border-radius: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  color: #ffffff;
  margin-top: 19px;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Message.vue